import React, { useState, useEffect } from "react";
import axios from "axios";
import Fade from "react-reveal/Fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import SectionWrapper, {
  Container,
  HeaderWrapper,
  HeaderLeft,
  Eyebrow,
  SectionTitle,
  HeaderRight,
  SwiperWrapper,
  BlogCard,
  CardImageBox,
  CardContent,
  PostDate,
  PostTitle,
  ReadArticleLink,
} from "./blogs.style";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const fallbackBlogs = [
  {
    id: "1",
    title: "Hair Loss Treatment Options: What Works for Different Types of Hair Loss",
    image: "/home/Delhi-Hair-Wigs-Price-Guide.webp",
    date: "14 OCT, 2026",
    link: "https://www.radiancehairstudio.com/blog/hair-loss-treatment-options/",
  },
  {
    id: "2",
    title: "Common Causes of Hair Fall and Effective Ways to Control It Naturally",
    image: "/home/Hair-Extension-In-Delhi.png",
    date: "9 OCT, 2026",
    link: "https://www.radiancehairstudio.com/blog/common-causes-of-hair-fall/",
  },
  {
    id: "3",
    title: "How to Find a Reliable Hair Wig Specialist in Delhi",
    image: "/home/hair-wig-for-men-in-Delhi.webp",
    date: "29 SEP, 2026",
    link: "https://www.radiancehairstudio.com/blog/how-to-choose-the-best-hair-wig-for-men-in-delhi/",
  },
];

const formatDate = (dateString) => {
  if (!dateString) return "14 OCT, 2026";
  try {
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return dateString;
    const day = d.getDate();
    const month = d.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const year = d.getFullYear();
    return `${day} ${month}, ${year}`;
  } catch (e) {
    return dateString;
  }
};

const cleanTitle = (rawTitle) => {
  if (!rawTitle) return "";
  return rawTitle
    .replace(/&#8217;s/g, "'s")
    .replace(/&#8217;/g, "'")
    .replace(/&#8216;/g, "'")
    .replace(/&amp;/g, "&")
    .replace(/&#038;/g, "&")
    .replace(/&quot;/g, '"');
};

const Blogs = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let isMounted = true;
    async function fetchPosts() {
      try {
        const response = await axios.get(
          "https://www.radiancehairstudio.com/blog/wp-json/wp/v2/posts?per_page=6"
        );
        if (isMounted && Array.isArray(response.data) && response.data.length > 0) {
          setPosts(response.data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    }

    fetchPosts();
    return () => {
      isMounted = false;
    };
  }, []);

  const displayPosts = posts.length > 0
    ? posts.map((post, idx) => ({
        id: post.id || idx,
        title: cleanTitle(post.title?.rendered || "Featured Hair Care Blog"),
        image: post.featured_image_url || fallbackBlogs[idx % fallbackBlogs.length].image,
        date: formatDate(post.date),
        link: post.link || "https://www.radiancehairstudio.com/blog/",
      }))
    : fallbackBlogs;

  return (
    <SectionWrapper id="featuredBlogs">
      <Container>
        <Fade top>
          <HeaderWrapper>
            <HeaderLeft>
              <Eyebrow>Resources</Eyebrow>
              <SectionTitle>
                Featured <span className="highlight">Blogs.</span>
              </SectionTitle>
            </HeaderLeft>

            <HeaderRight>
              <a
                href="https://www.radiancehairstudio.com/blog/"
                target="_blank"
                rel="noopener noreferrer"
                className="view-blog-btn"
              >
                View Blog <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </HeaderRight>
          </HeaderWrapper>
        </Fade>

        <Fade bottom>
          <SwiperWrapper>
            <Swiper
              spaceBetween={24}
              slidesPerView={3}
              breakpoints={{
                320: {
                  slidesPerView: 1.15,
                  spaceBetween: 14,
                },
                576: {
                  slidesPerView: 1.6,
                  spaceBetween: 16,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              }}
            >
              {displayPosts.map((post) => (
                <SwiperSlide key={post.id}>
                  <BlogCard
                    as="a"
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <CardImageBox>
                      <img
                        loading="lazy"
                        src={post.image}
                        alt={post.title}
                      />
                    </CardImageBox>

                    <CardContent>
                      <PostDate>{post.date}</PostDate>
                      <PostTitle>{post.title}</PostTitle>
                      <ReadArticleLink className="read-link">
                        Read article <FontAwesomeIcon icon={faArrowRight} />
                      </ReadArticleLink>
                    </CardContent>
                  </BlogCard>
                </SwiperSlide>
              ))}
            </Swiper>
          </SwiperWrapper>
        </Fade>
      </Container>
    </SectionWrapper>
  );
};

export default Blogs;
